import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { IneligibleReasons } from '@src/components/Employee/PaymentRequests/EditPaymentRequest/IneligibleReasons';
import { getBasePath, Messages, TrackableButton } from 'pe-core-frontend';
import { useMemo } from 'react';
export const PaymentRequestMessages = ({ paymentRequest, messages, onClose, }) => {
    const filteredMessages = useMemo(() => messages
        .filter(({ params }) => (params?.reasons || []).length === 0 && !params?.title) // Don't show ineligible reasons here
        .map(error => ({
        ...error,
        params: {
            ...(error.params || {}),
            link: (text) => (_jsx(TrackableButton, { btnType: 'link', enText: 'Employer policy', tag: 'payment_request', target: '_blank', rel: 'noopener noreferrer', href: `${getBasePath()}/reimbursement-policy`, children: text })),
        },
    })), [messages]);
    const ineligibleMessages = useMemo(() => messages.filter(({ params }) => (params?.reasons || []).length > 0), // Show ineligible reasons separately
    [messages]);
    return (_jsxs(_Fragment, { children: [_jsx(Messages, { messages: filteredMessages, onClose: onClose }), ineligibleMessages.map(({ value, params }) => (_jsx(IneligibleReasons, { paymentRequest: paymentRequest, reasons: params?.reasons, type: params?.type }, value)))] }));
};
